import { render, staticRenderFns } from "./MyZs5.vue?vue&type=template&id=ff05180c&scoped=true&"
import script from "./MyZs5.vue?vue&type=script&lang=js&"
export * from "./MyZs5.vue?vue&type=script&lang=js&"
import style0 from "./MyZs5.vue?vue&type=style&index=0&id=ff05180c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff05180c",
  null
  
)

export default component.exports